<template>
    <section class="l-section l-section--main o-start">
        <div class="l-container l-container--main l-container--horizontalPaddings">
            <div class="l-row l-row--center">
                <div class="l-row__column l-row__column--7">
                    <div class="l-row">
                        <div class="l-row__column">
                            <h1 class="a-title">Witaj</h1>
                            <p class="a-text">
                              Aby korzystać z panelu B2B dla klientów Take a Fruit musisz posiadać konto.
                            </p>
                        </div>
                    </div>
                    <div class="l-row l-row--verticalCenter">
                        <div class="l-row__column l-row__column--6">
                            <a-button
                                class="a-button a-button--primary a-button--fullwidth"
                                @click="$router.push({ name: 'dashboard-register'})"
                            >
                                Zarejestruj się
                            </a-button>
                        </div>
                        <div class="l-row__column l-row__column--6">
                            <a-button
                                class="a-button a-button--fullwidth"
                                @click="$router.push({ name: 'dashboard-login'})"
                            >
                                Zaloguj się
                            </a-button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
export default {
    data() {
        return {
            vatin: ''
        }
    },
    metaInfo: {
        title: 'TAKE A FRUIT B2B',
        titleTemplate: 'TAKE A FRUIT B2B'
    },
    computed: {
        customerStatus() {
            return this.$store.getters.customerStatus
        }
    }
}
</script>
